import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-candidate-resume-achievements',
  templateUrl: './candidate-resume-achievements.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeAchievementsComponent {
  @Input()
  achievements: string[];

  @Input()
  keywords: string[];

  track = (index: number, item: string) => item;
}
